export const CREATOR_ACQUISITION_PROMPT_SURFACE = 'Homepage';
export const CREATOR_ACQUISITION_PROMPT_PLACEMENT = 'homepage_before_top_destinations';
export const CREATOR_ACQUISITION_PROMPT_EXPERIMENT_NAME =
    'ebweb_creator_acquisition_prompt_consumer_pages';
export const CREATOR_ACQUISITION_PROMPT_VARIANT = 'treatment';

export const CREATOR_ACQUISITION_PROMPT_EVENT_RENDERED =
    'creator_acquisition_prompt_module_rendered';
export const CREATOR_ACQUISITION_PROMPT_EVENT_CLICKED = 'creator_acquisition_prompt_module_clicked';

export type CreatorPromptDevice = 'desktop' | 'tablet' | 'mobile';

export const getCreatorPromptDevice = (width?: number): CreatorPromptDevice => {
    const w = width ?? (typeof window !== 'undefined' ? window.innerWidth : 1440);
    if (w <= 660) {
        return 'mobile';
    }
    if (w <= 1080) {
        return 'tablet';
    }
    return 'desktop';
};

export const buildCreatorPromptCtaUrl = (device: CreatorPromptDevice): string => {
    const params = new URLSearchParams({
        creator_prompt_surface: CREATOR_ACQUISITION_PROMPT_SURFACE,
        creator_prompt_placement: CREATOR_ACQUISITION_PROMPT_PLACEMENT,
        creator_prompt_device: device,
        creator_prompt_variant: CREATOR_ACQUISITION_PROMPT_VARIANT,
    });
    return `/create/?${params.toString()}`;
};
